import styled, {keyframes, css} from 'styled-components';

export const StatementMainWrap = styled.div(
  props => `
    width:100%;
    display: flex;
    border-radius: 10px;
    box-shadow: 0 3px 7px 0 rgba(0, 0, 0, 0.1);
    background-color: ${props.theme.colors.white.base};
  `,
);

export const StatementInnerWrap = styled.div(
  props => `
    width:100%;
    display: flex;
    flex-direction: column;
    @media (max-width: 768px){
      min-height: 200px;
    }
  `,
);

export const StatementHeadWrap = styled.div(
  props => `
    width:100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: ${props.theme.spacing.large.l18} ${props.theme.spacing.large.l20} ${props.theme.spacing.large.l15};

    @media (max-width: 768px){
      flex-direction: column;
    }
  `,
);

export const StatementMobileHandle = styled.div(
  props => `
    width:60%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding-right: ${props.theme.spacing.large.l20};
    @media (max-width: 768px) {
      padding-bottom: ${props.theme.spacing.base};
      padding-right: 0;
      width:100%;
    }
  `,
);

export const StatementHeadText = styled.p(
  props => `
    font-size: ${props.theme.font.large.font22};
    color: ${props.theme.colors.grey.base};
    font-weight: ${props.theme.font.fontWeight.black};

    @media (max-width: 768px){
      font-size: ${props.theme.font.large.font16};
    }
  `,
);

export const StatementTimeWrap = styled.div(
  props => `
    display: flex;
    justify-content: flex-end;
    flex-direction: row;
    align-items: center;
  `,
);

export const StatementTimeInnerWrap = styled.div(
  props => `
    display: flex;
    border:1px solid ${props.theme.colors.grey.lighte7};
    border-radius: ${props.theme.misc.borderRadius.base};
    padding: ${props.theme.spacing.large.l12} ${props.theme.spacing.large.l20};
    @media (max-width: 768px){
      position:relative;
    }
  `,
);

export const FromTimeWrap = styled.div(
  props => `
    display: flex;
    align-items: center;
    cursor: pointer;
  `,
);

export const CalendarWrapper = styled.div(
  props => `
    display: flex;
    position: absolute;
    @media (max-width: 768px){
      top:1.2rem;
      left: 0;
    }
  `,
);

export const CalendarWrapperFrom = styled(CalendarWrapper)(
  props => `
    margin-left: -21rem;
    @media (max-width: 768px){
      margin-left:0;
    }
  `,
);

export const CalendarWrapperTo = styled(CalendarWrapper)(
  props => `
    margin-left: -6rem;
    @media (max-width: 768px){
      margin-left:0;
    }
  `,
);

export const FromTimeText = styled.p(
  props => `
    font-size: ${props.theme.font.base};
    color: ${props.theme.colors.grey.base};
  `,
);

export const FromTimeMainText = styled.p(
  props => `
    font-size: ${props.theme.font.large.font14};
    color: ${props.theme.colors.black.base};
    font-weight: ${props.theme.font.fontWeight.bold};
    margin-left: ${props.theme.spacing.base};
  `,
);

export const TimeBreakDiv = styled.div(
  props => `
    width:1px;
    height: 2rem;
    display: flex;
    margin: 0 ${props.theme.spacing.large.l20};
    transform: rotate(45deg);
  `,
);

export const StatementSummaryWrap = styled.div(
  props => `
    width:100%;
    display: flex;
    flex-direction: column;
    height: 50rem;
    overflow: auto;

    table{
      border-collapse: collapse;
      th{
        position: sticky;
        top:0;
        padding: ${props.theme.spacing.base};
        border: 1px solid ${props.theme.colors.grey.lighte7};
        background-color: ${props.theme.colors.blue.lightef};
        font-size: ${props.theme.font.base};
        color: ${props.theme.colors.grey.base};
        font-weight: ${props.theme.font.fontWeight.bold};
        text-align: left;
        border-top: none;
      }
      td{
        padding: ${props.theme.spacing.base};
        border: 1px solid ${props.theme.colors.grey.lighte7};
        font-size: ${props.theme.font.base};
        color: ${props.theme.colors.grey.base};
      }
    }
  `,
);

export const StatementMobileWrap = styled.div(
  props => `
    width:100%;
    display: flex;
    flex-direction: column;
    min-height: 100px;
  `,
);

export const StatementBody = styled.div(
  props => `
    width:100%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: auto;
    color: ${props.theme.colors.grey.light9b};
    font-size: ${props.theme.font.large.font22};
    flex-direction: column;
    span {
      font-size: ${props.theme.font.large.font16};
    }
  `,
);

export const StatementActionsWrap = styled.div(
  props => `
    width:100%;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: ${props.theme.spacing.large.l15} ${props.theme.spacing.large.l25};
    box-shadow: 0 3px 30px 0 rgba(0, 0, 0, 0.1);
    background-color: ${props.theme.colors.white.base};
    border-radius: 0 0 1rem 1rem;
    z-index:2;
  `,
);

export const ActionInnerWrap = styled.div(
  props => `
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-left: ${props.theme.spacing.large.l20};
    cursor: pointer;
  `,
);

export const ActionIconWrap = styled.div(
  props => `
    width:2rem;
    height: 2rem;
    margin-right: ${props.theme.spacing.base};
  `,
);

export const ActionTextWrap = styled.a(
  props => `
    font-size: ${props.theme.font.base};
    color: ${props.theme.colors.blue.base};
    font-weight: ${props.theme.font.fontWeight.bold};
    text-decoration: none;

    &:hover{
      color: ${props.theme.colors.blue.base}; 
    }
  `,
);

export const DownloadIconWrap = styled.a(
  props => `
    width:4rem;
    height: 4rem;
    background-color: ${props.theme.colors.blue.base};
    border-radius: 0.4rem;
    text-decoration: none;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 1rem;
    color: ${props.theme.colors.white.base};
    &:hover{
      color: ${props.theme.colors.white.base};
    }
  `,
);

const LoaderContainer = styled.div(
  props => `
    background-image: linear-gradient(to right, #f4f4f4, #ececec);
  `,
);

export const TimeLoader = styled(LoaderContainer)(
  props => `
    margin-left: 1rem;
    width: 8rem;
    height: 2rem;
  `,
);

export const LeftRightFrame = keyframes`
  0% {
    transform: translateX(-100%);
  }
  50% {
    transform: translateX(0%);
  }
  100% {
    transform: translateX(100%);
  }
`;

export const LoaderDiv = styled.div(
  props => css`
    width: 30rem;
    height: 0.5rem;
    border-radius: 0.4rem;
    background-color: ${props.theme.colors.grey.lighte7};
    overflow-x: hidden;
    position: relative;
    top: 40%;
    left: 50%;
    transform: translate(-50%, -50%);
    &:before {
      animation: ${LeftRightFrame} 3s infinite;
      background-image: linear-gradient(
        to right,
        transparent,
        ${props.theme.colors.blue.base},
        transparent
      );
      content: '';
      height: 0.5rem;
      left: 0;
      overflow: hidden;
      position: absolute;
      right: 0;
      top: 0;
    }
    &:after {
      content: '';
      height: 0.5rem;
      left: 0;
      overflow: hidden;
      position: absolute;
      right: 0;
      top: 0;
    }
  `,
);

export const TabContainerItem = styled.div(props => ``);

export const MobileStatementInnerWrap = styled.div(
  props => `
    width:100%;
    display: flex;
    overflow: scroll;
    scroll-behavior: smooth;
    border:1px solid ${props.theme.colors.grey.lighte7};
  `,
);

export const FixedTableHeadMobile = styled.div(
  props => `
    width:30%;
    display: flex;
    flex-direction: column;
    max-height:330px;

    table{
      border-collapse: collapse;
      th{
        position: sticky;
        top:0;
        padding: ${props.theme.spacing.base};
        border: 1px solid ${props.theme.colors.grey.lighte7};
        background-color: ${props.theme.colors.blue.lightef};
        font-size: ${props.theme.font.base};
        color: ${props.theme.colors.grey.base};
        font-weight: ${props.theme.font.fontWeight.bold};
        text-align: left;
        border-top: none;
      }
      td{
        padding: ${props.theme.spacing.base};
        border: 1px solid ${props.theme.colors.grey.lighte7};
        font-size: ${props.theme.font.base};
        color: ${props.theme.colors.grey.base};
      }
    }
  `,
);
